/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Tip_Qr_TInputs */



/**
* | output |
* | --- |
* | "Let players check themselves in" |
*
* @param {Tournament_Wiz_Tip_Qr_TInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_qr_t = /** @type {((inputs?: Tournament_Wiz_Tip_Qr_TInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Qr_TInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Laissez les joueurs s'enregistrer eux-mêmes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deje que los jugadores hagan el check-in solos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Deixe os jogadores fazerem o próprio check-in")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lascia che i giocatori facciano il check-in da soli")
	return /** @type {LocalizedString} */ ("Let players check themselves in")
});